export const mapIdToFileName: { [key: string]: string } = {
    '1': 'en-EN',
    '3': 'it-IT',
    '4': 'fr-FR',
    '5': 'es-ES',
    '6': 'de-DE',
    '7': 'ja-JP',
};

export const mapIdToLang: { [key: string]: string } = {
    '1': 'en',
    '3': 'it',
    '4': 'fr',
    '5': 'es',
    '6': 'de',
    '7': 'ja'
}

export const mapLangToFileName: { [key: string]: string } = {
    'en': 'en-EN',
    'it': 'it-IT',
    'fr': 'fr-FR',
    'es': 'es-ES',
    'de': 'de-DE',
    'ja': 'ja-JP'
};
